import { ReactNode, useEffect, useState } from 'react';
import { ExpandMoreRounded, ExpandLessRounded } from '@mui/icons-material';
import {
  Post,
} from 'lib/types';
import { useCurrentUser } from 'lib/contexts/ApplicationState';
import { AuditLogList } from './AuditLogList';

interface Props {
  post: Post;
}

export const PostLog = ({ post }: Props) => {
  const currentUser = useCurrentUser();
  const [showLog, setShowLog] = useState(false);
  const [dateSection, setDateSection] = useState<ReactNode | null>(null);

  useEffect(() => {
    if (post) {
      // Putting this date section in the useEffect ensures that we don't get hydration
      // warnings when the server-rendered timestamp differs from the client-rendered timestamp.
      setDateSection(
        <div className="font-extralight text-sm py-4">
          <p>{`Posted Date - ${new Date(post.postedAt).toLocaleString()}`}</p>
          <p>{`Tracked Since - ${new Date(post.createdAt).toLocaleString()}`}</p>
          {post.updatedAt
            && <p>{`Updated At - ${new Date(post.updatedAt).toLocaleString()}`}</p>}
        </div>,
      );
    } else {
      setDateSection(null);
    }
  }, [post]);

  return (
    <>
      {dateSection}
      {currentUser
        && (
          <button
            type="button"
            className="hover:underline"
            onClick={() => setShowLog(!showLog)}
            data-testid="history-button"
          >
            {showLog ? (
              <>
                <ExpandLessRounded />
                Hide
              </>
            ) : (
              <>
                <ExpandMoreRounded />
                Show
              </>
            ) }
            {' '}
            Gondola history
          </button>
        )}

      {showLog && (
        <AuditLogList postId={post.id} />
      )}
    </>
  );
};
